import React, { useEffect, useState, useMemo } from 'react'
import server from '../../../api/server.js'
import { FaTimes } from 'react-icons/fa'
import ModernTimeDropdown from '../../layouts/modernDropdown.jsx'
import ModernDateRangePicker from "../../layouts/ModernDateRangePicker.jsx"
import { useNavigate } from 'react-router-dom'
import "../../../dashboard-components/loader.css"
import { useToast } from '../../../context/ToastContext.jsx'
import { Settings, ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react'

const AgentFeedbackReports = ({serviceID, clientID}) => {
  const { showToast } = useToast();
    const [service_id, setService_id] = useState(null)
    const [client_id, setClient_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [showOnlyAgentReports, setShowOnlyAgentReports] = useState(false)
    const [currentTab, setCurrentTab] = useState('Project Reports')
    const [reportsData, setReportsData] = useState([])
    const [selectedReportId, setSelectedReportId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showGenerateReportModal, setShowGenerateReportModal] = useState(false)
    const [dateRange, setDateRange] = useState({start: "", end: ""})
    const [selectedReportCategory, setSelectedReportCategory] = useState('')
    const [selectedEmployee, setSelectedEmployee] = useState([])
    const [balanceValid, setBalanceValid] = useState(0)
    const [reportCategoryOptions] = useState([
      {label: "Project Reports", value: "Project Reports"},
      {label: "Agent Reports", value: "Agent Reports"}
    ])
    const [employeeOptions, setEmployeeOptions] = useState([])
    const [selectedFrequency, setSelectedFrequency] = useState('')
    const [selectedStatus, setSelectedStatus] = useState('')
    const [frequencyOptions, setFrequencyOptions] = useState([
      {label: "Weekly (Every Monday)", value: "Weekly"},
      {label: "Fortnightly (Every 1st and 15th)", value: "Fortnightly"},
      {label: "Monthly (Every 1st of the month)", value: "Monthly"},
    ])
    const [showGenerateSystemReportModal, setShowGenerateSystemReportModal] = useState(false)
    const [generateTrainingSessions, setGenerateTrainingSessions] = useState(false)
    const [reportLoading, setReportLoading] = useState(false)
    const [totalCost, setTotalCost] = useState(0)
    const [currentBalance, setCurrentBalance] = useState(0)
    const [affectedCount, setAffectedCount] = useState(0)
    const [eligibleEmployees, setEligibleEmployees] = useState(0)
    const [canGenerate, setCanGenerate] = useState(false)
    const [isCheckingCredits, setIsCheckingCredits] = useState(false)
    const [loadingSystemConfiguration, setLoadingSystemConfiguration] = useState(false)
    const [errorReports, setErrorReports] = useState([])
    const [showErrorCases, setShowErrorCases] = useState(false)
    const [sortConfig, setSortConfig] = useState({ field: null, direction: null })
    const [errorSortConfig, setErrorSortConfig] = useState({ field: null, direction: null })
    const getSystemConfiguration = async () => {
      setLoadingSystemConfiguration(true)
      let res = await server.getSystemConfiguration(client_id, service_id, email, 'agent-feedback', 'reports')
      if(res.status === 200){
        let resp = await res.json()
        setSelectedFrequency(resp.frequency === 'Weekly' ? 'Weekly (Every Monday)' : resp.frequency === 'Fortnightly' ? 'Fortnightly (Every 1st and 15th)' : 'Monthly (Every 1st of the month)')
        setSelectedStatus(resp.status)
      }
      setLoadingSystemConfiguration(false)
    }

    // Helper function to get status styling
    const getStatusStyle = (status) => {
      const normalizedStatus = status?.toLowerCase();
      switch (normalizedStatus) {
        case 'received':
          return {
            backgroundColor: '#f3f4f6',
            color: '#6b7280',
            text: 'Queued'
          };
        case 'processing':
          return {
            backgroundColor: '#e0e7ff',
            color: '#4338ca',
            text: 'Processing'
          };
        case 'success':
          return {
            backgroundColor: '#dcfce7',
            color: '#166534',
            text: 'Success'
          };
        case 'failed':
          return {
            backgroundColor: '#fecaca',
            color: '#dc2626',
            text: 'Failed'
          };
        default:
          return {
            backgroundColor: '#f3f4f6',
            color: '#6b7280',
            text: status || 'Unknown'
          };
      }
    };
    const toggleReportCategory = (value) => {
      setSelectedReportCategory(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value])
    }
    const toggleEmployee = (value) => {
      setSelectedEmployee(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value])
    }

    const [filters, setFilters] = useState({
        employee: null,
      time: 'Last 7 Days',
      customRangeType: 'between',
    })
    const [dummyFilterData, setDummyFilterData] = useState({
        employees: [],
        times: [
          "This Month",
          "Last Month",
          "Last 30 Days",
          "Last 3 Months",
          "Custom Range"]
      });
      const navigate = useNavigate()
      const handleFilterChange = (e, key) => {
        let value = e.target.value;
        if (key === 'time' && value !== 'Custom Range') {
          setFilters((prev) => ({ 
            ...prev, 
            [key]: value,
            customRangeType: 'between',
            customStart: '',
            customEnd: '',
          }));
        } else {
          setFilters((prev) => ({ ...prev, [key]: value }));
        }
      };
    const [role] = useState(()=> {
        const userCookie = getCookie('dashboard_login_user_creds');
        if (userCookie) {
          const userData = JSON.parse(userCookie);
          const role = userData.role
          return role
        }
        return 'admin';
    })

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    function create_date_range(start_time, end_time){
        let start_date = new Date(start_time * 1000);
        let end_date = new Date(end_time * 1000);
        return `${start_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} - ${end_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`;
    }
  const getValueForSort = (item, field) => {
    if (!item) return null;
    switch (field) {
      case 'report_id':
        return item.report_id != null ? String(item.report_id).toLowerCase() : null;
      case 'employee_id':
        return item.employee_id != null ? String(item.employee_id).toLowerCase() : null;
      case 'report_start_time':
        return item.report_start_time != null ? Number(item.report_start_time) : null;
      case 'date_range':
        return item.date_range != null ? String(item.date_range).toLowerCase() : null;
      case 'createdat':
        return item.createdat != null ? Number(item.createdat) : null;
      case 'created_by':
        return item.created_by != null ? String(item.created_by).toLowerCase() : null;
      case 'status':
        return item.status != null ? String(item.status).toLowerCase() : null;
      case 'error':
        return item.error != null ? String(item.error).toLowerCase() : null;
      default: {
        const v = item[field];
        if (v == null) return null;
        const num = Number(v);
        if (!Number.isNaN(num) && String(v).trim() !== '') return num;
        return String(v).toLowerCase();
      }
    }
  };
  const sortArray = (list, field, direction) => {
    if (!field || !direction) return list;
    const arr = [...list];
    const factor = direction === 'asc' ? 1 : -1;
    arr.sort((a, b) => {
      const va = getValueForSort(a, field);
      const vb = getValueForSort(b, field);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return factor * (va - vb);
      return factor * String(va).localeCompare(String(vb));
    });
    return arr;
  };
  const arrowClass = (cfg, field, dir) => (cfg.field === field && cfg.direction === dir ? 'text-indigo-600' : 'text-gray-300 group-hover:text-gray-400');
  const getAriaSort = (cfg, field) => (cfg.field === field ? (cfg.direction === 'asc' ? 'ascending' : 'descending') : 'none');
  const cycleSort = (cfg, setCfg, field) => {
    let nextDir = 'asc';
    if (cfg.field === field) {
      nextDir = cfg.direction === 'asc' ? 'desc' : (cfg.direction === 'desc' ? null : 'asc');
    }
    setCfg(nextDir ? { field, direction: nextDir } : { field: null, direction: null });
  };
  const renderArrows = (cfg, field, setCfg) => {
    if (cfg.field === field && cfg.direction === 'asc') {
      return (
        <ArrowUp className={`h-3 w-3 ${arrowClass(cfg, field, 'asc')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'asc' });}} />
      );
    }
    if (cfg.field === field && cfg.direction === 'desc') {
      return (
        <ArrowDown className={`h-3 w-3 -mt-0.5 ${arrowClass(cfg, field, 'desc')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'desc' });}} />
      );
    }
    return (
      <ChevronsUpDown className={`h-3 w-3 ${arrowClass(cfg, field, 'none')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'asc' });}} />
    );
  };
  const renderMainArrows = (field) => renderArrows(sortConfig, field, setSortConfig);
  const displayReports = useMemo(() => (
    sortConfig.field ? sortArray(reportsData.filter(r => r.status !== 'failed'), sortConfig.field, sortConfig.direction) : reportsData.filter(r => r.status !== 'failed')
  ), [reportsData, sortConfig]);
  const displayErrorReports = useMemo(() => (
    errorSortConfig.field ? sortArray(errorReports, errorSortConfig.field, errorSortConfig.direction) : errorReports
  ), [errorReports, errorSortConfig]);

    useEffect(() => {
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
        if (user) {
          setEmail(user.email);
        }
        if (serviceID) {
          setService_id(serviceID);
        }
        if(clientID){
          setClient_id(clientID)
        }
        if(role === 'employee'){
          setShowOnlyAgentReports(true)
          setCurrentTab('Agent Reports')
          handleFilterChange({'target': {'value': user.name}}, 'employee')
        }
    }, [serviceID, clientID, role]);
    
    useEffect(() => {
        if (client_id && service_id && email) {
          getAgentFeedbackReports()
        }
    }, [client_id, service_id, email, filters, currentTab]);

    useEffect(() => {
        // Check if start date is after June 22, 2025
        const minDate = new Date('2025-06-22');
        const startDate = dateRange.start ? new Date(dateRange.start) : null;
        const isStartDateValid = startDate && startDate > minDate;
        
        if (dateRange.start && dateRange.end && selectedReportCategory && 
            (selectedReportCategory !== 'Agent Reports' || selectedEmployee.length > 0) && 
            isStartDateValid) {
            checkReportCredits()
        } else {
            setCanGenerate(false)
        }
    }, [dateRange, selectedReportCategory, selectedEmployee, generateTrainingSessions])

    const getAgentFeedbackReports = async () => {
      try {
        setLoading(true);
       let res = await server.getReportDataList(client_id, service_id, 'agent-feedback', 'agent_reports', email, filters.time, filters.customStart, filters.customEnd, currentTab, filters.employee)
       if(res.status === 200){
        let resp = await res.json()
        setReportsData(resp.data)
        
        // Filter error cases from the same data
        const failedReports = resp.data.filter(report => report.status === 'failed')
        setErrorReports(failedReports)
        
        let res1 = await server.getAdvancedFilterDetailsAgentFeedback(client_id, service_id, email, 'agent-feedback', 'overview')
        if(res1.status === 200){
          let resp1 = await res1.json()
          setDummyFilterData(prev => ({
            ...prev,
            employees: resp1.employee_id,
        }));
        setEmployeeOptions(resp1.employee_id)
        }
       }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
    const getReadableDateFromEpoch = (time) => {
        const date = new Date(time * 1000);
        return date.toLocaleDateString('en-GB', {
          day:   '2-digit',
          month: 'short',   // e.g. "Apr"
          year:  'numeric'
        });
      }; 
    const handleViewDetails = (id) => {
        setSelectedReportId(id)
        navigate(`/analytics/${client_id}/${service_id}/agent-feedback/reports/${id}`)
    }

  const handleGenerateReport = () => {
    setShowGenerateReportModal(true)
  }

  const generateReport = async () => {
    if (!canGenerate) {
      showToast("Insufficient credits or incomplete form. Please check your selection.", "error");
      return;
    }

    try{
      setReportLoading(true)
      let obj = {
        "start_time": convertToISTEpoch(new Date(dateRange.start), 'start'),
            "end_time": convertToISTEpoch(new Date(dateRange.end), 'end'),
            "client_id": client_id,
            "service_id": service_id, 
            "report_category": (selectedReportCategory === "Agent Reports") ? "agent_reports" : "team_reports",
            "employee_ids": selectedEmployee,
            "email": email,
            "menu": "agent-feedback",
            "submenu": "reports",
            "generate_training_session": generateTrainingSessions ? 1 : 0
      }
      let res = await server.generateReport(obj)
      if(res.status === 200){
        let resp = await res.json()
        showToast("Report generation in progress. We will notify you once completed.", "success");
        getAgentFeedbackReports()
      }else{
        showToast("Error generating report. Please try again.", "error");
      }
    } catch (error) {
      showToast("Error generating report. Please try again.", "error");
    } finally {
      setReportLoading(false)
      setShowGenerateReportModal(false)
      setDateRange({start: "", end: ""})
      setSelectedReportCategory('')
      setSelectedEmployee([])
      setTotalCost(0)
      setCurrentBalance(0)
      setAffectedCount(0)
      setEligibleEmployees(0)
      setCanGenerate(false)
      setIsCheckingCredits(false)
      setGenerateTrainingSessions(false)
    }
  }

  const convertToISTEpoch = (date, type = 'start') => {
    // Create a new Date object to avoid mutating the original
    const targetDate = new Date(date);
    
    // Set time based on type
    if (type === 'start') {
      targetDate.setHours(0, 0, 0, 0); // 00:00:00.000
    } else if (type === 'end') {
      targetDate.setHours(23, 59, 59, 999); // 23:59:59.999
    }
    
    // Convert to IST (UTC+5:30)
    // JavaScript Date works in local timezone, so we need to adjust for IST
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30 in milliseconds
    const utcTime = targetDate.getTime() + (targetDate.getTimezoneOffset() * 60 * 1000);
    const istTime = utcTime + istOffset;
    
    // Return epoch timestamp in seconds
    return Math.floor(istTime / 1000);
  };

  const checkReportCredits = async () => {
    try {
      setIsCheckingCredits(true)
      
      let res = await server.getAgentFeedbackConversations(
        client_id,
        service_id,
        email,
        'agent-feedback',
        'reports',
        convertToISTEpoch(new Date(dateRange.start), 'start'),
        convertToISTEpoch(new Date(dateRange.end), 'end'),
        (selectedReportCategory === "Agent Reports") ? "agent_reports" : "team_reports",
        selectedEmployee,
        generateTrainingSessions ? 1 : 0
      )
      
      if(res.status === 200) {
        let response = await res.json()
        let data = response.data
        setTotalCost(data.total_cost || 0)
        setCurrentBalance(data.current_balance || 0)
        setAffectedCount(data.total_report_count || 0)
        setEligibleEmployees(data.eligible_employees || 0)
        setBalanceValid(data.valid || 0)
        
        if((data.eligible_employees || 0) === 0) {
          setCanGenerate(false)
        } else if(((data.total_cost || 0) <= (data.current_balance || 0)) || data.valid === 1) {
          setCanGenerate(true)
        } else {
          setCanGenerate(false)
        }
      }
    } catch (error) {
      setCanGenerate(false)
    } finally {
      setIsCheckingCredits(false)
    }
  }

  const saveSystemReport = async () => {
    let freq = selectedFrequency === 'Weekly (Every Monday)' ? 'Weekly' : selectedFrequency === 'Fortnightly (Every 1st and 15th)' ? 'Fortnightly' : 'Monthly'
    let res = await server.saveSystemConfiguration({
      client_id: client_id,
      service_id: service_id,
      email: email,
      menu: 'agent-feedback',
      submenu: 'reports',
      frequency: freq,
      status: selectedStatus
    })
    if(res.status === 200){
      showToast("System report configuration saved successfully", "success")
    }else{
      showToast("Error saving system report configuration", "error")
    }
    setShowGenerateSystemReportModal(false)
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowGenerateReportModal(false);
        setShowGenerateSystemReportModal(false);
      }
    }
    if (showGenerateReportModal || showGenerateSystemReportModal) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    }
  }, [showGenerateReportModal, showGenerateSystemReportModal])

  return (
    <div className="py-3 px-5 bg-gray-50 font-sans">
        <h1 class="text-xl font-semibold mb-2">
              <span class="text-gray-500">Agent Feedback &gt;</span>
              <span class="text-gray-900">  Reports</span>
        </h1>
        <div className="text-sm text-gray-500">View weekly and monthly reports for your team</div>
        <div className='flex justify-between items-center mt-4'>
          <div className="flex space-x-6 text-gray-600">
                      {role !== 'employee' && <button 
                      className={`px-3 py-2 ${currentTab === 'Project Reports' ? 'bg-gray-100 text-gray-800 font-medium rounded' : 'hover:text-gray-900'}`}
                      onClick={() => setCurrentTab('Project Reports')}
                      >
                      Project Reports
                      </button>}
                      <button 
                      className={`px-3 py-2 ${currentTab === 'Agent Reports' ? 'bg-gray-100 text-gray-800 font-medium rounded' : 'hover:text-gray-900'}`}
                      onClick={() => setCurrentTab('Agent Reports')}
                      >
                      Agent Reports
                      </button>
          </div>
          {role !== 'employee' && (
            <div className='flex items-center gap-2'>
              <button className='px-4 py-2 bg-gray-100 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-200 flex items-center gap-2' onClick={()=>{setShowGenerateSystemReportModal(true); getSystemConfiguration();}} style={{marginRight: "10px"}}>
                <Settings style={{height: "18px"}}/> System Report
              </button>
              <button className='bg-indigo-600 text-white px-4 py-2 rounded-md' onClick={()=>handleGenerateReport()} style={{marginRight: "10px"}}>
                Generate Report
              </button>
            </div>
          )}
        </div>
            <div className="bg-white rounded-lg shadow-sm p-4 mb-4 mt-4">
                <div className="text-sm font-medium text-gray-700 mb-4">Quick Filters</div>
                <div className="flex gap-4 mb-4">
                        {currentTab === 'Agent Reports' && <ModernTimeDropdown isDisabled={role === 'employee'} placeholder="Select Employee" value={filters.employee} onChange={(e) => handleFilterChange(e, 'employee')} options={dummyFilterData.employees}/>}
                        <ModernTimeDropdown placeholder="Select Time Duration" value={filters.time} onChange={(e) => handleFilterChange(e, 'time')} options={dummyFilterData.times}/>
                        </div>
                        {filters.time === "Custom Range" && (
                          <div className="mb-2">
                            <ModernDateRangePicker
                              startDate={filters.customStart}
                              endDate={filters.customEnd}
                              rangeType={filters.customRangeType || "between"}
                              maxRangeDays={90}
                              placeholder="Select Time Range"
                              onChange={({ startDate, endDate, rangeType }) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  customStart: startDate,
                                  customEnd: endDate,
                                  customRangeType: rangeType || "between",
                                }))
                              }
                            />
                          </div>
                        )}
                <div className="flex gap-4 flex-wrap">
                        {Object.keys(filters).map(
                          (key) =>{
                            if (key === 'customStart' || key === 'customEnd' || key === 'customRangeType') {
                              return null;
                            }
                            if (key === 'time' && filters.time === 'Custom Range') {
                              return null;
                            }
                            return filters[key] && (
                              <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                                <span className="capitalize text-indigo-600">{key} - {filters[key]}</span>
                                {key!=='time' && !(role === 'employee' && key === 'employee') && <button
                                  className="ml-2 text-gray-600"
                                  onClick={() => setFilters((prev) => ({ ...prev, [key]: null }))}
                                >
                                  <FaTimes />
                                </button>}
                              </div>
                            )
                          })}
                          {filters.time === "Custom Range" && filters.customStart && (filters.customRangeType === "after" || filters.customEnd) && (
                            <div className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                              <span className="text-indigo-600">
                                time - {filters.customStart} {filters.customRangeType === "after" ? "onwards" : `to ${filters.customEnd}`}
                              </span>
                              <button
                                className="ml-2 text-gray-600"
                                onClick={() => setFilters((prev) => ({ ...prev, time: '', customRangeType: 'between', customStart: '', customEnd: '' }))}
                              >
                                <FaTimes />
                              </button>
                            </div>
                          )}
                  </div>
                  <div className='flex items-center justify-end w-full'>
                    <input type="checkbox" onChange={(e)=>setShowErrorCases(e.target.checked)}/>
                    <label className='px-2 py-1.5 text-sm font-medium text-gray-700 focus:outline-none'>Show Error Cases</label>
                  </div>
            </div>
            
            <div>
                {currentTab === 'Project Reports' && <div>
                    <div style={{width: "100%", background: "white"}} className="rounded-lg shadow-sm">
                      {!loading && !showErrorCases && <div>
                        <div className="rounded-lg overflow-hidden">
                          <div className="overflow-x-auto" style={{maxWidth: "calc(100vw - 18rem)"}}>
                            <div style={{maxHeight: "50vh", overflow: "auto"}}>
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead style={{ position: "sticky", top: "0", background: "white"}}>
                                    <tr className="text-left">
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider rounded-tl-lg" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_id')}>
                                        <span>Report ID</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_id')}</span>
                                      </button>
                                    </th>
                                        {/* <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{ fontSize: "13px", fontWeight: "400"}}>Report Type</th> */}
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_start_time')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_start_time')}>
                                            <span>Date Range</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_start_time')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'createdat')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'createdat')}>
                                            <span>Created At</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('createdat')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'created_by')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'created_by')}>
                                            <span>Created By</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('created_by')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'status')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'status')}>
                                            <span>Status</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('status')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider rounded-tr-lg" style={{ fontSize: "13px", fontWeight: "400"}}>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {displayReports.map((report) => (
                                        <tr key={report.id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.report_id}</td>
                                        {/* <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.report_type}</td> */}
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{create_date_range(report.report_start_time, report.report_end_time)}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{new Date(report?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.created_by}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                          <span style={{
                                            fontSize: "0.7rem",
                                            textTransform: "capitalize",
                                            backgroundColor: getStatusStyle(report.status).backgroundColor,
                                            color: getStatusStyle(report.status).color,
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-block'
                                          }}>
                                            {getStatusStyle(report.status).text}
                                          </span>
                                        </td>
                                        <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem", cursor: "pointer"}} onClick={()=>handleViewDetails(report.report_id)}>View Details</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                      </div>}
                      {!loading && showErrorCases && (
                        <div className="rounded-lg overflow-hidden">
                          <div className="overflow-x-auto" style={{maxWidth: "calc(100vw - 18rem)"}}>
                            <div style={{maxHeight: "50vh", overflow: "auto"}}>
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead style={{ position: "sticky", top: "0", background: "white"}}>
                                  <tr className="text-left">
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'report_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'report_id')}>
                                        <span>Report ID</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_id')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'report_start_time')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'report_start_time')}>
                                        <span>Date Range</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_start_time')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'created_at')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'created_at')}>
                                        <span>Created At</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('created_at')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'created_by')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'created_by')}>
                                        <span>Created By</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('created_by')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'status')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'status')}>
                                        <span>Status</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('status')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(errorSortConfig, 'error')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(errorSortConfig, setErrorSortConfig, 'error')}>
                                        <span>Error</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('error')}</span>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {displayErrorReports.map((report) => (
                                    <tr key={report.id} className="border-b hover:bg-gray-50">
                                      <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.report_id}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{create_date_range(report.report_start_time, report.report_end_time)}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{new Date(report?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.created_by}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                        <span style={{
                                          fontSize: "0.7rem",
                                          textTransform: "capitalize",
                                          backgroundColor: getStatusStyle(report.status).backgroundColor,
                                          color: getStatusStyle(report.status).color,
                                          padding: '4px 8px',
                                          borderRadius: '4px',
                                          display: 'inline-block'
                                        }}>
                                          {getStatusStyle(report.status).text}
                                        </span>
                                      </td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.error || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {
                        loading && (
                          <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                              <div className="loader"></div>
                              <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                          </div>
                        )
                      }
                    </div>
                </div>}
                {currentTab === 'Agent Reports' && <div>
                    <div style={{width: "100%", background: "white"}} className="rounded-lg shadow-sm">
                      {!loading && !showErrorCases && <div>
                        <div className="rounded-lg overflow-hidden">
                          <div className="overflow-x-auto" style={{maxWidth: "calc(100vw - 18rem)"}}>
                            <div style={{maxHeight: "50vh", overflow: "auto"}}>
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead style={{ position: "sticky", top: "0", background: "white"}}>
                                    <tr className="text-left">
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_id')}>
                                            <span>Report ID</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_id')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'employee_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'employee_id')}>
                                            <span>Employee ID</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('employee_id')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_start_time')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{ fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_start_time')}>
                                            <span>Date Range</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_start_time')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'createdat')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{ fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'createdat')}>
                                            <span>Created At</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('createdat')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'created_by')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{ fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'created_by')}>
                                            <span>Created By</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('created_by')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" aria-sort={getAriaSort(sortConfig, 'status')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{ fontSize: "13px", fontWeight: "400"}}>
                                          <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'status')}>
                                            <span>Status</span>
                                            <span className="ml-1 flex flex-col leading-none">{renderMainArrows('status')}</span>
                                          </button>
                                        </th>
                                        <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider rounded-tr-lg" style={{ fontSize: "13px", fontWeight: "400"}}>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {displayReports.map((report) => (
                                        <tr key={report.id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.report_id}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.employee_id}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{create_date_range(report.report_start_time, report.report_end_time)}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{new Date(report?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.created_by}</td>
                                        <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                          <span style={{
                                            fontSize: "0.7rem",
                                            textTransform: "capitalize",
                                            backgroundColor: getStatusStyle(report.status).backgroundColor,
                                            color: getStatusStyle(report.status).color,
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-block'
                                          }}>
                                            {getStatusStyle(report.status).text}
                                          </span>
                                        </td>
                                        <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem", cursor: "pointer"}} onClick={()=>handleViewDetails(report.report_id)}>View Details</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                      </div>}
                      {!loading && showErrorCases && (
                        <div className="rounded-lg overflow-hidden">
                          <div className="overflow-x-auto" style={{maxWidth: "calc(100vw - 18rem)"}}>
                            <div style={{maxHeight: "50vh", overflow: "auto"}}>
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead style={{ position: "sticky", top: "0", background: "white"}}>
                                  <tr className="text-left">
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_id')}>
                                        <span>Report ID</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_id')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'employee_id')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'employee_id')}>
                                        <span>Employee ID</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('employee_id')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'report_start_time')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'report_start_time')}>
                                        <span>Date Range</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('report_start_time')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'createdat')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'createdat')}>
                                        <span>Created At</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('createdat')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'created_by')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'created_by')}>
                                        <span>Created By</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('created_by')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'status')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'status')}>
                                        <span>Status</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('status')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(sortConfig, 'error')} className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-700 tracking-wider" style={{background: "white", fontSize: "13px", fontWeight: "400"}}>
                                      <button type="button" className="flex items-center group" onClick={() => cycleSort(sortConfig, setSortConfig, 'error')}>
                                        <span>Error</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderMainArrows('error')}</span>
                                      </button>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {displayErrorReports.map((report) => (
                                    <tr key={report.id} className="border-b hover:bg-gray-50">
                                      <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.report_id}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.employee_id}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{create_date_range(report.report_start_time, report.report_end_time)}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{new Date(report?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.created_by}</td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                        <span style={{
                                          fontSize: "0.7rem",
                                          textTransform: "capitalize",
                                          backgroundColor: getStatusStyle(report.status).backgroundColor,
                                          color: getStatusStyle(report.status).color,
                                          padding: '4px 8px',
                                          borderRadius: '4px',
                                          display: 'inline-block'
                                        }}>
                                          {getStatusStyle(report.status).text}
                                        </span>
                                      </td>
                                      <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{report.error || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                    {
                      loading && (
                        <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                            <div className="loader"></div>
                            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                        </div>
                      )
                    }
                    </div>
                </div>}
            </div>
            {showGenerateReportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{background: "rgba(0,0,0,0.5)"}}>
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md overflow-y-auto" style={{ height: "93vh", maxWidth: "800px" }}>
            {!reportLoading && <div>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Generate Report</h3>
              <button 
                onClick={() => {setShowGenerateReportModal(false); setDateRange({start: "", end: ""}); setSelectedReportCategory(''); setSelectedEmployee([]); setTotalCost(0); setCurrentBalance(0); setAffectedCount(0); setEligibleEmployees(0); setCanGenerate(false); setIsCheckingCredits(false); setGenerateTrainingSessions(false)}}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes style={{color: "slategray"}}/>
              </button>
            </div>
            
            {/* Date Range */}
            <div style={{overflow: "auto", height: "64vh", padding: "10px"}}>
            <div className="mb-4">
              
              <div className="grid grid-cols-2 gap-4 z-11">
                <div className="col-span-2">
                  <ModernDateRangePicker
                    startDate={dateRange.start}
                    endDate={dateRange.end}
                    maxRangeDays={90}
                    placeholder="Select Report Date Range"
                    onChange={({ startDate, endDate }) =>
                      setDateRange({ start: startDate, end: endDate })
                    }
                  />
                </div>
              </div>
              {dateRange.start && new Date(dateRange.start) <= new Date('2025-06-22') && (
                <div className="text-red-500 text-sm mt-2">
                  Start date must be after June 22, 2025
                </div>
              )}
            </div>
            
            {/* Processing Status */}
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 text-sm">Report Category</label>
              <ModernTimeDropdown placeholder="Select Report Category" value={selectedReportCategory} onChange={(e)=>setSelectedReportCategory(e.target.value)} options={reportCategoryOptions.map(option => option.label)}/>
            </div>

            {/* Record Type */}
            {selectedReportCategory === 'Agent Reports' && <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 text-sm">Employee</label>
              <div className="border rounded-lg" style={{overflow: "auto", height: "27vh"}}>
                <div className="bg-gray-100 rounded-t-lg">
                  <label className="flex items-center p-2">
                    <input
                      type="checkbox" 
                      className="h-3 w-3 text-indigo-600 rounded-lg text-sm border" class="global-input"
                      style={{ accentColor: 'rgb(79 70 229)' }}
                      checked={selectedEmployee.length === employeeOptions.length} 
                      onChange={() => {
                        if (selectedEmployee.length === employeeOptions.length) {
                          setSelectedEmployee([]);
                        } else {
                          setSelectedEmployee(employeeOptions);
                        }
                      }}
                    />
                    <span className="ml-2 text-gray-700 font-medium text-sm">Select All</span>
                  </label>
                </div>
                <div className="overflow-y-auto ">
                  {employeeOptions.map(option => (
                    <label key={option} className="flex items-center p-2 hover:bg-gray-50 border-t border-gray-200">
                      <input
                        type="checkbox" 
                        className="h-3 w-3 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500 text-sm" class="global-input"
                        style={{ accentColor: 'rgb(79 70 229)' }}
                        checked={selectedEmployee.includes(option)}
                        onChange={() => toggleEmployee(option)}
                      />
                      <span className="ml-2 text-gray-700 text-sm">{option}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>}
            <div>
              <input onChange={()=>setGenerateTrainingSessions(!generateTrainingSessions)} value={generateTrainingSessions} type="checkbox" className="h-3 w-3 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500 text-sm" class="global-input" style={{ accentColor: 'rgb(79 70 229)' }}/>
              <span className="ml-2 text-gray-700 text-sm font-bold">Also, generate training sessions for these reports.</span>
            </div>
            </div>
            <div className="mb-2">
                <div className='text-sm text-blue-600 mb-4'>
                <p className='mb-1'>Note:</p>
                <ul className='list-disc list-inside ml-2'>
                  <li>For Project Reports, agent level reports will be automatically generated</li>
                  <li>Minimum 5 conversations per employee is required for report generation</li>
                </ul>
              </div>
            </div>
            </div>}
            {
              reportLoading && (
                <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                  <div className="loader"></div>
                  <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                </div>
              )
            }
            
            {/* Apply To and Actions */}
            <div className="flex pt-4 border-t border-gray-200">
              <div className="flex-grow">
                <span className="font-medium text-base flex items-center">
                  {totalCost > 0 && <span className="block text-sm text-gray-500">[Est. Credits: {Math.round(totalCost, 2) || '-'} | Current Balance: {Math.round(currentBalance, 2) || '-'}]</span>
                }</span>
              {selectedReportCategory === 'Agent Reports' && eligibleEmployees > 0 && (totalCost <= currentBalance || balanceValid === 1) && <span className="text-sm text-gray-500 block" style={{marginTop: "0.4rem"}}>
                Eligible employees: {eligibleEmployees}
              </span>}
              {eligibleEmployees === 0 && <span className="text-sm text-red-500 block" style={{marginTop: "0.4rem", fontStyle: "italic"}}>
                No eligible employees. Please try with different filters.
              </span>}
              {eligibleEmployees > 0 && (totalCost > currentBalance && balanceValid === 0) && <span className="text-sm text-red-500 block" style={{marginTop: "0.4rem", fontStyle: "italic"}}>
                Insufficient Credits. Please recharge or change filters.
              </span>}
              </div>
              <div className="flex space-x-3">
                <button 
                  onClick={() => {setShowGenerateReportModal(false); setDateRange({start: "", end: ""}); setSelectedReportCategory(''); setSelectedEmployee([]); setTotalCost(0); setCurrentBalance(0); setAffectedCount(0); setEligibleEmployees(0); setCanGenerate(false); setIsCheckingCredits(false); setGenerateTrainingSessions(false)}}
                  className="px-4 py-2 border border-gray-300 rounded text-gray-700 text-base"
                >
                  Cancel
                </button>
                <button 
                  className="px-4 py-2 rounded text-white font-medium text-base disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: 'rgb(79 70 229)' }}
                  onClick={generateReport}
                  disabled={!canGenerate || isCheckingCredits}
                >
                  {isCheckingCredits ? 'Checking...' : 'Generate Report'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {
        showGenerateSystemReportModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{background: "rgba(0,0,0,0.5)"}}>
            <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-md" style={{ height: "43vh", maxWidth: "500px" }}>
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-gray-900">Configure System Report</h3>
                <button onClick={() => {setShowGenerateSystemReportModal(false)}} className="text-gray-500 hover:text-gray-700">
                  <FaTimes style={{color: "slategray"}}/>
                </button>
              </div>
              {!loadingSystemConfiguration && <div className="mb-4" style={{height: "25vh"}}>
                <div className="mb-4">
                  <label className="block mb-1 font-medium text-gray-700 text-sm">Frequency</label>
                  <ModernTimeDropdown width='w-full' placeholder="Select Frequency" value={selectedFrequency} onChange={(e)=>setSelectedFrequency(e.target.value)} options={frequencyOptions.map(option => option.label)}/>
                </div>
                <div className="mb-4">
                  <label className="block mb-1 font-medium text-gray-700 text-sm">Status</label>
                  <ModernTimeDropdown width='w-full' placeholder="Select Status" value={selectedStatus} onChange={(e)=>setSelectedStatus(e.target.value)} options={['Active', 'Inactive']}/>
                </div>
              </div>}
              {loadingSystemConfiguration && (
                <div className="flex justify-center items-center" style={{ height: "25vh", flexDirection: "column" }}>
                  <div className="loader"></div>
                  <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                </div>
              )}
              <div className="flex space-x-3 justify-end">
                <button 
                  onClick={() => {setShowGenerateSystemReportModal(false)}}
                  className="px-4 py-2 border border-gray-300 rounded text-gray-700 text-base"
                >
                  Cancel
                </button>
                <button 
                  className="px-4 py-2 rounded text-white font-medium text-base disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: 'rgb(79 70 229)' }}
                  onClick={saveSystemReport}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )
      }
        </div>
  )
}

export default AgentFeedbackReports;